import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST';
export const FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS';
export const FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE = 'FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE';

const method = 'GET';
const buildRAv2HomeworkResultDetailUrl = (groupId) =>
  buildUrl(`/ra-v2-groups/${groupId}/homework-result-detail`);

export function fetchRAv2HomeworkResultDetailIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method,
      url: buildRAv2HomeworkResultDetailUrl(groupId),
    })) {
      return false;
    }

    return dispatch(fetchRAv2HomeworkResultDetail(groupId));
  };
}

export function fetchRAv2HomeworkResultDetail(groupId) {
  return (dispatch) => {
    const url = buildRAv2HomeworkResultDetailUrl(groupId);

    const payload = fetch(url);

    return dispatch(fetchRAv2HomeworkResultDetailRequest()).payload
      .then((response) => dispatch(fetchRAv2HomeworkResultDetailSuccess(response)))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(fetchRAv2HomeworkResultDetailSuccess([]));
        }

        return dispatch(fetchRAv2HomeworkResultDetailFailure(error));
      });

    function fetchRAv2HomeworkResultDetailRequest() {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_REQUEST,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchRAv2HomeworkResultDetailSuccess(successPayload) {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS,
        payload: successPayload,
        url,
        method,
        groupId,
      });
    }

    function fetchRAv2HomeworkResultDetailFailure(error) {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_DETAIL_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultDetail/actions.js